/**
 * 前后端共享常量库
 */

// IPC (Inter-Process Communication) 通信 Channel 枚举
export enum IpcChannels {
  // 示例: 获取应用版本
  GET_APP_VERSION = 'get-app-version',
  // 示例: 发送系统通知
  SHOW_NOTIFICATION = 'show-notification',
}

// 通用业务常量
export const APP_CONSTANTS = {
  // 统一接口请求超时，当前先放宽到 90s，避免私信相关链路在慢接口下过早失败。
  REQUEST_TIMEOUT: 90_000,
};
